export default function Bookmark({ flag, side = "left", index, backgroundColor="bg-[#00000099]", extraClass, titleSize }) {
    return (
        <div key={index} className={`flex flex-row items-center gap-4  w-full p-3 text-white ${backgroundColor} 
        rounded-xl
        md:rounded-none
        ${side === "left" ? "md:rounded-l-xl" : "md:rounded-r-xl"}
        `}>
            {flag.img && <img src={flag.img} alt={flag.title} className='w-16 shrink-0' />}
            <div className={extraClass}>
                <p className={`${titleSize} font-semibold text-start w-full`}>{flag.title}</p>
                <p className="text-start w-full">{flag.subtitle}</p>
            </div>
        </div>
    );
}
